
import React, {useContext, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import type {RootState} from "../Store";
import {setCart} from "../redux/Order";
import Loader from "../components/Loader";
import {addTransaction, clearData} from "../redux/Transaction";
import Button from "../components/Button";
import TransactionServiece, {Webhook} from "../services/TransactionService";
import {useNavigate, useParams} from "react-router-dom";

export default function App() {

    const dispatch = useDispatch();
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState(""); // New state for message type
    const navigate = useNavigate();
    const {paymentBackTrackId} = useParams();
    const data = useSelector((state: RootState) => state);

    useEffect(() => {

        if (localStorage.getItem("order") && data.order.totalPrice == 0) {

            let order = localStorage.getItem("order");

            if (order === null) {
                order = "";
            }

            dispatch(setCart(JSON.parse(order)));

            if (localStorage.getItem("paymentBackTrackId") == paymentBackTrackId) {

                setMessage("Payment succeeded!");
                setMessageType("success");

                SubmitPayment();

                localStorage.setItem("paymentBackTrackId","");
                localStorage.setItem("order","");

            }else{

            }

        }

        if (localStorage.getItem("order") === ""){
            moveToOrder();
        }

    }, [data.order,paymentBackTrackId]);

    const moveToOrder = () => {
        navigate("/order");
    };

    const SubmitPayment = async () => {

        let orderString = localStorage.getItem("order");

        if (orderString === null) {
            orderString = "";
        }

        let order = JSON.parse(orderString);

        let transaction: any = {};

        transaction.stripe_id = paymentBackTrackId;
        transaction.amount = data.order.totalPrice;
        transaction.totalPrice = order.totalPrice;
        transaction.tax = order.totalTax;
        transaction.unitPrice = order.items[0].price;
        transaction.pour_id = order.items[0].id;
        transaction.cart_id = data.cart.detail.id;
        transaction.qty = order.items[0].qty;
        transaction.customer_id = localStorage.getItem("customer_id");
        transaction.company_code = process.env.REACT_APP_COMPANY;

        const dataPromise = await TransactionServiece.addTransaction(transaction);

        dispatch(addTransaction(dataPromise));

    }

    return (
        <div className="p-6">
            <div className="space-y-6">
                <h4 className="text-2xl font-semibold text-gray-900 ">
                    Order summary
                </h4>
                {data.order.items &&
                    data.order.items.map((employee: any, index: number) => {
                        return (
                            <>
                                <div className="space-y-4" key={index}>
                                    <div className="space-y-2">
                                        <dl className="flex items-center justify-between gap-4">
                                            <dt className="text-gray-500 ">
                                                {employee.name} ({(employee.qty).toFixed(0)} {employee.unitName})
                                            </dt>
                                            <dd className="text-base font-medium text-gray-900 ">
                                                ${employee.price.toFixed(2)}
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </>
                        );
                    })}

                {data.order.totalPrice > 0 && (
                    <>
                        <dl className="flex items-center justify-between gap-4">
                            <dt className="text-gray-500 ">Tax {data.cart.detail.tax}% :{" "}</dt>
                            <dd className="text-base font-medium text-gray-900 ">
                                {data.order.totalTax.toFixed(2)}
                            </dd>
                        </dl>
                        <dl className="flex items-center justify-between gap-4 border-t border-gray-200 pt-2 dark:border-gray-700">
                            <dt className="text-lg font-bold text-gray-900 ">
                                Total
                            </dt>
                            <dd className="text-lg font-bold text-gray-900 ">
                                ${data.order.totalPrice.toFixed(2)}
                            </dd>
                        </dl>
                    </>
                )}

            </div>

            {message && (
                <div
                    id="payment-message"
                    className={`flex justify-center text-lg font-semibold p-2 rounded-md ${
                        messageType === "error" ? "bg-red" : "bg-green"
                    }`}
                >
                    {message}
                </div>
            )}

            {!message && <Loader/>}

            <>
                <Button style="primary" className={"mt-3"} type="button" onClick={moveToOrder}> Continue </Button>
            </>

        </div>
    );
}
